import React from 'react';
import { Box, Button, Modal, TextHeading, useMediaSize, useModal, } from '@ally/metronome-ui';
import whichEnv from '@ally/which-env';
var aaosDesktopEnvs = {
    local: 'https://www-cit2.ally.com/auto/online-services/access/create-user-profile.html',
    dev: 'https://www-cit2.ally.com/auto/online-services/access/create-user-profile.html',
    qa1: 'https://www-uat1.ally.com/auto/online-services/access/create-user-profile.html',
    qa2: 'https://www-uat2.ally.com/auto/online-services/access/create-user-profile.html',
    qa3: 'https://www-uat2.ally.com/auto/online-services/access/create-user-profile.html',
    cap: 'https://www-cap.int.ally.com/auto/online-services/access/create-user-profile.html',
    psp: 'https://www-prodsupt.ally.com/auto/online-services/access/create-user-profile.html',
    fix: 'https://www-fix.int.ally.com/auto/online-services/access/create-user-profile.html',
    prod: 'https://www.ally.com/auto/online-services/access/create-user-profile.html',
};
var aaosMobileEnvs = {
    local: 'https://m-cit2.ally.com/auto/index.html?pageName=enroll-online',
    dev: 'https://m-cit2.ally.com/auto/index.html?pageName=enroll-online',
    qa1: 'https://m-uat1.ally.com/auto/index.html?pageName=enroll-online',
    qa2: 'https://m-uat2.ally.com/auto/index.html?pageName=enroll-online',
    qa3: 'https://m-uat2.ally.com/auto/index.html?pageName=enroll-online',
    cap: 'https://m-cap.int.ally.com/auto/index.html?pageName=enroll-online',
    psp: 'https://m-prodsupt.ally.com/auto/index.html?pageName=enroll-online',
    fix: 'https://m-fix.int.ally.com/auto/index.html?pageName=enroll-online',
    prod: 'https://m.ally.com/auto/index.html?pageName=enroll-online',
};
var headingRef = React.createRef();
var ModalContent = function (_a) {
    var isInPortal = _a.isInPortal, navigateToOleCustomer = _a.navigateToOleCustomer;
    var shouldUseMobileLinks = useMediaSize('MdDown');
    var getAAOSEnv = function () {
        if (shouldUseMobileLinks) {
            return whichEnv(window.location.href).pick(aaosMobileEnvs);
        }
        return whichEnv(window.location.href).pick(aaosDesktopEnvs);
    };
    var handleOnClickBank = function () {
        if (isInPortal) {
            window.location.href = '/enroll';
        }
        else {
            navigateToOleCustomer();
        }
    };
    var handleOnClickAuto = function () {
        window.location.href = getAAOSEnv();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mb: "lg" },
            React.createElement(TextHeading, { tag: "h1", size: "md", tabIndex: -1, ref: headingRef }, "Choose your account type.")),
        React.createElement(Box, { alignItems: "center", gridRowGap: "10px", display: "flex", flexDirection: "column", mb: "md" },
            React.createElement(Button, { onClick: handleOnClickBank, text: "Bank, Invest, Credit Card, or Mortgage", variant: "outline" }),
            React.createElement(Button, { onClick: handleOnClickAuto, text: "Auto Financing", variant: "outline" }))));
};
var ModalTriggerComponent = function () {
    var showModal = useModal().showModal;
    return (React.createElement(Button, { withAllyTM: "createAProfile", variant: "link", text: "Create a profile", onClick: showModal }));
};
export var ChooseEnrollLOBModal = function (_a) {
    var isInPortal = _a.isInPortal, navigateToOleCustomer = _a.navigateToOleCustomer;
    return (React.createElement(Modal, { content: React.createElement(ModalContent, { isInPortal: isInPortal, navigateToOleCustomer: navigateToOleCustomer }), ref: headingRef, trigger: React.createElement(ModalTriggerComponent, null), width: "md" }));
};
//# sourceMappingURL=ChooseEnrollLOBModal.js.map